// Active-branch selection for the org admin.
//
// When an org admin logs in with branch_avail=true, they pick a branch on the
// BranchSelect page; that choice is stored here and sent as ?branch= on
// branch-scoped list APIs (e.g. the employee list). A branch admin / employee
// never uses this — their data is already server-scoped to their own branch.
const ACTIVE_BRANCH_ID = "active_branch_id";
const ACTIVE_BRANCH_NAME = "active_branch_name";
const ACTIVE_BRANCH_MAIN = "active_branch_main";

export const setActiveBranch = (id, name = "", isMain = false) => {
    if (id === null || id === undefined || id === "") {
        clearActiveBranch();
        return;
    }
    sessionStorage.setItem(ACTIVE_BRANCH_ID, String(id));
    sessionStorage.setItem(ACTIVE_BRANCH_NAME, name || "");
    sessionStorage.setItem(ACTIVE_BRANCH_MAIN, isMain ? "true" : "false");
};

export const getActiveBranchId = () => {
    const v = sessionStorage.getItem(ACTIVE_BRANCH_ID);
    return v && v !== "null" && v !== "" ? v : null;
};

export const getActiveBranchName = () =>
    sessionStorage.getItem(ACTIVE_BRANCH_NAME) || "";

// Whether the currently active branch is the organisation's main branch.
export const getActiveBranchIsMain = () =>
    sessionStorage.getItem(ACTIVE_BRANCH_MAIN) === "true";

export const clearActiveBranch = () => {
    sessionStorage.removeItem(ACTIVE_BRANCH_ID);
    sessionStorage.removeItem(ACTIVE_BRANCH_NAME);
    sessionStorage.removeItem(ACTIVE_BRANCH_MAIN);
};

// True when the logged-in user is an org admin who has branches to choose from.
export const isBranchAvail = () =>
    sessionStorage.getItem("branch_avail") === "true";

// Boolean key: is this an ORG ADMIN currently in the org-wide "Dashboard
// Overview" mode (active branch == "all")? In this mode the sidebar is limited
// to Dashboard / Employee List / Reports. Inside a specific branch this is
// false and the normal full menu applies.
export const isOrgOverview = () =>
    isBranchAvail() && getActiveBranchId() === "all";
